import { TbUpload } from "react-icons/tb";
import { ButtonLink } from "@/common/ButtonLink";
import { Dropzone } from "@/components/form/Dropzone";
import { useSubmit } from "@/submit/SubmitProvider";
import styles from "./StatementUpload.module.css";

const statementAccept = {
  "image/png": [".png"],
  "image/webp": [".webp"],
  "image/jpeg": [".jpg", ".jpeg"],
  "application/pdf": [".pdf"],
};

export function StatementUpload() {
  const { submit, next, pov } = useSubmit();

  return (
    <div className={styles.uploadStatement}>
      {pov === "customer" && (
        <p>Upload your current statement below to being your remortgage.</p>
      )}
      {pov === "broker" && <p>Upload the statement below.</p>}
      <Dropzone
        onFiles={(files) => submit.mutate({ files: files.slice(0, 3) })}
        accept={statementAccept}
        multiple
        loading={submit.isPending}
        hint="10MB max / .pdf, .jpeg, .jpg, .webp / up to 3 files"
      >
        <TbUpload size={32} />
        <p>Drag & drop files here, or click to select</p>
      </Dropzone>
      <small>
        or <ButtonLink onClick={next}>enter data manually</ButtonLink>
      </small>
    </div>
  );
}
